<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="leadStatus.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Novo Lead Status",
          routerName: "RegisterLeadStatus",
        },
      ],
      leadStatus: {
        name: "",
      },
      leadStatusParams: this.$route.params,
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      leadsStatusData: "Company/leadsStatus",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerLeadsStatus",
      "consultLeadsStatus",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.leadStatus?.id
        ? "Status do lead editado com sucesso!"
        : "Status do lead cadastrado com sucesso!";

      await this.registerLeadsStatus(this.leadStatus);
      this.$router.push({ name: "ListLeadsStatus" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.leadStatusParams &&
      Object.keys(this.leadStatusParams).length > 0
    ) {
      await this.consultLeadsStatus(this.leadStatusParams);
      this.dataProps = {
        name: this.leadsStatusData.name,
        id: this.leadStatusParams.id,
        module: "Company",
        type: "LeadStatus",
      };
      this.leadStatus = this.leadsStatusData;
      this.links[1].name = this.leadStatus.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
